var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Starting-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Starting-Components-Part-2",
    transform: "translate(-1538.000000, -3994.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-/-Banner-/-Error-Copy",
    transform: "translate(1522.000000, 3983.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-Icon",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.188288562,8.54543117 L8.54543127,0.191507228 C8.7964826,-0.0595440981 9.20351722,-0.0595440981 9.45456855,0.191507228 L17.8110741,8.54543117 C18.0621255,8.7964825 18.0621255,9.20351712 17.8110741,9.45456845 L9.45456855,17.808867 C9.20351722,18.0599183 8.7964826,18.0599183 8.54543127,17.808867 L0.188288562,9.45456845 C-0.0627627636,9.20351712 -0.0627627636,8.7964825 0.188288562,8.54543117 Z M8.9999998,17.1997449 L17.201952,8.99999981 L8.9999998,0.80062929 L0.797410516,8.99999981 L8.9999998,17.1997449 Z M9,12.3750001 C9.62131875,12.3750001 10.125,12.8786814 10.125,13.5000001 C10.125,14.1213189 9.62131875,14.6250001 9,14.6250001 C8.37868125,14.6250001 7.875,14.1213189 7.875,13.5000001 C7.875,12.8786814 8.37868125,12.3750001 9.00000005,12.3750001 Z M9.00000004,13.8750001 C9.20710691,13.8750001 9.37500003,13.7071069 9.37500003,13.5000001 C9.37500003,13.2928932 9.20710691,13.1250001 9.00000004,13.1250001 C8.79289317,13.1250001 8.62500005,13.2928932 8.62500005,13.5000001 C8.62500005,13.7071069 8.79289317,13.8750001 9.00000005,13.8750001 Z M8.25000017,11.6249999 C8.0428933,11.6249999 7.87500022,11.4571068 7.87500019,11.2499999 L7.5000002,3.7500001 C7.5000002,3.54289323 7.66789332,3.37500011 7.8750002,3.37500011 L10.1250001,3.37500011 C10.332107,3.37500011 10.5000002,3.54289323 10.5000002,3.75000012 L10.1250001,11.2499999 C10.1250001,11.4571068 9.957107,11.6249999 9.75000015,11.6249999 L8.25000022,11.6249999 Z M9.75000028,4.12500017 L8.28750022,4.12500017 L8.62500023,10.8750002 L9.37500027,10.8750002 L9.75000028,4.12500017 Z",
    id: "IconError",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Exclamation-Mark-SPECIAL",
    transform: "translate(7.071429, 3.214286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.428571, 0.160714)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.385ff527f7b2507147c69c36b9a6b4bf.svg";
export { ForwardRef as ReactComponent };